import { BillingModelAlertDialogComponent } from './modules/IoTCore/apps/components/billing-alert-dialog/billingModelAlertDialog/biiling-model-dialog';
import { LoaderComponent } from "./modules/shared/loadersManager/loaders/loader-primary.component";
import { LoaderModule } from "./modules/shared/loadersManager/loaders.module";
import { BrowserModule } from "@angular/platform-browser";
import { MatDialogModule } from '@angular/material/dialog';

import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SharedModule } from "./modules/shared/shared.module";
import { CustomPreloadingStrategy } from "./modules/CustomPreloadingStrategy.services";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ErrorPageComponent } from "./modules/shared/error-page/error-page.component";
import { SharedDataService } from "./modules/shared/services/shared.service";
import { parkingAlertComponent } from "./modules/IoTCore/apps/components/parking-traffic/parking-traffic-alert.component";


@NgModule({
  declarations: [AppComponent,ErrorPageComponent,parkingAlertComponent, BillingModelAlertDialogComponent],
  imports: [BrowserModule, BrowserAnimationsModule, SharedModule, AppRoutingModule,MatDialogModule],
  providers: [CustomPreloadingStrategy,SharedDataService],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
